import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AccountState } from '../reducers/account.reducer';

export const selectAccountState = createFeatureSelector<AccountState>('account');

export const selectAccountDetails = createSelector(selectAccountState, (state: AccountState) => state.accountDetails);

export const selectAccountError = createSelector(selectAccountState, (state: AccountState) => state.error);

export const selectIsAccountDetailsLoaded = createSelector(selectAccountState, (state: AccountState) => state.isLoaded);
